
import { Component, Prop } from 'vue-property-decorator'
import { AppInput } from '@/components'
import { appAccountEntity } from '@/models/models'
import CommonForm from '@/mixins/CommonForm'
import '@/extensions/string'
import '@/extensions/Date'

@Component({
    components: {
        AppInput,
    },
})
export default class DetailAppleAccountForm extends CommonForm {
    @Prop() public value?: AppAccountEntity

    get account(): AppAccountEntity {
        return this.value ? this.value : appAccountEntity
    }

    get createdAt() {
        if (
            this.account.createdAt == null ||
            this.account.createdAt.isEmpty()
        ) {
            return ''
        }
        return new Date(this.account.createdAt).toHTMLFormat()
    }
}
